module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-bottom-stone-path.dffb9c4b.png";